import { buildRouteTree } from "utils/routeUtils";

export const routes = buildRouteTree({
	games: {
		all: null,
		category: null
	}
});
